import { Component, inject } from '@angular/core';
import { PreloaderService } from '../../services/preloader.service';

@Component({
  selector: 'app-preloader',
  imports: [],
  templateUrl: './preloader.html',
  styleUrl: './preloader.css',
})
export class Preloader {
  preloader = inject(PreloaderService);
}
